import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  InputBase,
} from "@mui/material";
import SingleChatScreen1 from "../SingleChat/index1";
import { CaseListType } from "../../../../../DataTypes/Case.type";
import CaseApi from "Service/Case.api";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { FormateCaseList } from "./Formatter";
import ImgPath from "Constants/Imgs";
import DateTime from "Utils/DateTime";
import { disconnectChatHub } from "Service/signalRService";
import NoData from "Components/NoData";
import Loader from "Components/Loader";
import { useMediaQuery, useTheme } from "@mui/material";
import ChatListComponent from "./ChatListComponent";
import ChatWindowComponent from "./ChatWindow";
import { useLocation } from "react-router-dom";

const WhatsAppChatListLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedCase, setSelectedCase] = useState<null | CaseListType>(null);
  const [showChatList, setShowChatList] = useState(true);
  const [allCases, setAllCases] = useState<CaseListType[]>([]);
// Effect to watch for notification ID once the list is available
  useEffect(() => {
    const targetId = location.state?.openCaseId;
    if (targetId && allCases.length > 0) {
      const targetCaseObject = allCases.find((c) => c.caseId === Number(targetId));
      if (targetCaseObject) {
        setSelectedCase(targetCaseObject);
        if (isMobile) setShowChatList(false);
        
        // Optional: Clear state so it doesn't trigger again on refresh
        window.history.replaceState({}, document.title);
      }
    }
  }, [location.state, allCases]);


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        height: "100%",
        backgroundColor: "#f0f2f5",
        overflow: "hidden",
      }}
    >
      {isMobile ? (
        showChatList ? (
          <ChatListComponent
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
            onListLoaded={(list: CaseListType[]) => setAllCases(list)}
          />
        ) : (
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        )
      ) : (
        <>
          <ChatListComponent
            setShowChatList={(value: boolean) => setShowChatList(value)}
            getSelectedCase={(caseData: CaseListType) =>
              setSelectedCase(caseData)
            }
            onListLoaded={(list: CaseListType[]) => setAllCases(list)}
          />
          <ChatWindowComponent selectedCase={selectedCase} setShowChatList={setShowChatList} />
        </>
      )}
    </Box>
  );
};

export default WhatsAppChatListLayout;
